import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';

const NestedErrorDetail = t.type({
    loc: t.tuple([t.string, t.number, t.string]),
    msg: t.string,
    type: t.string,
});

const NestedErrorDetailsArray = t.array(NestedErrorDetail);
export type GamprotectErrorType = t.TypeOf<typeof NestedErrorDetailsArray>;
const isGamprotectError = createGuard(NestedErrorDetailsArray);

export const getErrorMessage = (messageRaw: string): string => {
    const delimiter = `"detail":`;
    const message = messageRaw.replace('\\', '');
    const delimiterIndex = message.indexOf(delimiter);
    if (delimiterIndex === -1) {
        return message;
    }

    try {
        const rawErrorString = message.substring(delimiterIndex + delimiter.length).slice(0, -1);
        const errorObject = JSON.parse(rawErrorString);
        if (isGamprotectError(errorObject)) {
            const msg = errorObject[0]?.msg ?? null;
            if (msg === null) {
                return message;
            }
            return msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase();
        }
        return message;
    } catch (e) {
        console.error('Failed to parse nested error message:', e);
        return message;
    }
};
